<lui-avatar
  *ngIf="props['tooltip']"
  class="addons-wrapper__tooltip position-absolute d-print-none"
  [ngClass]="{
    'addons-wrapper__tooltip--inline': isInline,
    'addons-wrapper__tooltip--before': props['tooltip'].position === 'before',
    'addons-wrapper__tooltip--after': props['tooltip'].position === 'after',
  }"
  color="primary"
  size="20px"
  [matTooltip]="props['tooltip'].text"
  [useClickListener]="true"
>
  <mat-icon svgIcon="i"></mat-icon>
</lui-avatar>

<ng-template #matPrefix>
  <div *ngIf="props.addonLeft" class="addons-wrapper__affix ms-2">
    {{ props.addonLeft }}
  </div>
</ng-template>

<ng-container #fieldComponent></ng-container>

<ng-template #matSuffix>
  <span
    *ngIf="props.addonRight"
    class="addons-wrapper__affix"
    [class.me-2]="props.type === 'select'"
  >
    {{ props.addonRight }}
  </span>
</ng-template>
